import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p418823699841495040',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
